import { createFileRoute } from "@tanstack/react-router";
import { BookDetailPage } from "@/components/catalog/book-detail";
import { bookQuery } from "@/lib/catalog";

export const Route = createFileRoute("/_app/books/$id/")({
  loader: ({ context, params }) => context.queryClient.prefetchQuery(bookQuery(params.id)),
  component: BookRoute,
});

function BookRoute() {
  const { id } = Route.useParams();
  return <BookDetailPage bookId={id} />;
}
